export default {
  primaryMain: '#FAD40A',
  secondaryMid: '#120232',
  tertiaryMain: '#6013FB',
  tertiaryLight: '#FCFBFF',
  neutral: '#000000',
  white: '#ffffff',
  error: '#E55D3E',
  gray: '#eaeceb',
  grayLight: '#fcfbff',
  primaryNeutral: '#1F1C1C',
};
